/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Offset_FormInputs */



/**
* | output |
* | --- |
* | "Timecode offset form" |
*
* @param {Timecode_Offset_FormInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_offset_form = /** @type {((inputs?: Timecode_Offset_FormInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Offset_FormInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire de décalage de timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode-Offset-Formular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di offset del codice temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма смещения временного кода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de desplazamiento del código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码偏移表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードオフセットフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड ऑफ़सेट फ़ॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("formulário de deslocamento de código de tempo")
	return /** @type {LocalizedString} */ ("Timecode offset form")
});